import { Icon, IconsEnum } from 'components/Icons';
import { setAccordionFilter, setExpandWindowTipiScommessa } from 'features/sport/sportSlice';
import { useEffect, useRef, useState } from 'react';

import { ScommesseAccordionFilterPrimary } from 'components/scommesseAccordionFilterPrimary';
import classNames from 'classnames';
import styles from './ScommesseSearch.module.scss';
import { useAppDispatch } from 'lib/centralStore';
import { useGetLabelsByKeys } from 'hooks/useLingUI';

export type ScommesseSearchProps = {
  children: React.ReactNode;
  isMobile?: boolean;
  isActive?: boolean;
  openBtnText?: string;
  placeholder?: string;
  hasShowMore?: boolean;
  expandWindow?: boolean;
  numberOfScommesse: number;
  labelScommesseFound: string;
  // setExpandWindow?: Dispatch<SetStateAction<boolean>>;
  reset: Function;
  onChange: (_: string) => void;
};

export const ScommesseSearch = ({
  openBtnText,
  placeholder,
  hasShowMore,
  labelScommesseFound,
  children,
  numberOfScommesse,
  expandWindow,
  reset,
  isMobile,
  isActive = true,
  onChange,
}: ScommesseSearchProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const refOpen = useRef(isOpen);

  const inputRef = useRef<HTMLInputElement>(null);
  const [showMoreLabel, showLessLabel, labelChiudi] = useGetLabelsByKeys(['show-more', 'show-less', 'chiudi']);

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (isOpen !== refOpen.current) {
      refOpen.current = isOpen;
      inputRef.current!.value = '';
      onChange('');
    }
  }, [isOpen, onChange]);

  useEffect(() => {
    if (isMobile) {
      setIsOpen(true);
    }
  }, [isMobile]);

  return (
    <div className={classNames(styles.searchWrapper, { [styles.open]: isOpen, [styles.notClickable]: !isActive })}>
      <button
        className={styles.backBtn}
        onClick={(e) => {
          e.stopPropagation();
          setIsOpen(false);
        }}
      >
        <Icon iconId={IconsEnum.ARROW} className={styles.icon16} color={'var(--color-on-bg-primary)'} />
      </button>
      <button
        className={styles.searchBtn}
        onClick={() => {
          isActive && setIsOpen(true);
          dispatch(setAccordionFilter(true));
        }}
      >
        <Icon iconId={IconsEnum.SEARCH} className={styles.icon24} color={'var(--color-on-bg-primary)'} />
        <span className={styles.text}>{openBtnText}</span>
      </button>
      <input
        className={styles.search}
        type="search"
        name=""
        placeholder={placeholder}
        ref={inputRef}
        onChange={(e) => onChange(e.target.value)}
      />
      {/* NOTE questo bottone chiude e non applica filtraggio */}
      <button
        className={styles.closeBtn}
        onClick={(e) => {
          inputRef.current!.value = '';
          onChange('');
          e.stopPropagation();
          setIsOpen(false);
          reset();
        }}
      >
        <Icon iconId={IconsEnum.CLOSE} className={styles.icon16} color={'var(--color-on-bg-primary)'} />
        <span className={styles.closeText}>{labelChiudi}</span>
      </button>

      <div className={`${styles.results} ${expandWindow ? styles.expandWrapper : ''} `}>
        <ScommesseAccordionFilterPrimary
          className={expandWindow ? styles.expandContainer : ''}
          label={`${numberOfScommesse} ${labelScommesseFound}`}
          isBig
          hasShowMore={hasShowMore}
        >
          {children}
        </ScommesseAccordionFilterPrimary>
        {numberOfScommesse > 15 && isOpen && (
          <div className={styles.showMoreContainer}>
            <button
              type="button"
              className={styles.buttonShowMore}
              onClick={(e) => {
                e.stopPropagation(); // NOTE: INSERITO PER NON PROPAGARE LA VISUALIZZAZIONE
                dispatch(setExpandWindowTipiScommessa(!expandWindow));
              }}
            >
              <Icon
                iconId={expandWindow ? IconsEnum.MINUS_CIRCLE : IconsEnum.PLUS_CIRCLE}
                className={styles.iconShowMore}
                color="var(--color-primary)"
              />
              {expandWindow ? showLessLabel : showMoreLabel}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
